import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import Button from "../button"

const Alert = ({ blok, className }) => (
  <SbEditable content={blok}>
    <div className={`alert alert${blok.theme} ${className}`}>
      {blok.title && <p className="alert__title">{blok.title}</p>}
      {blok.content && (
        <div className="alert__content">
          {
            unified()
              .use(remarkParse)
              .use(remarkRehype)
              .use(rehypeReact, {
                createElement: React.createElement,
                components: remarkReactComponents,
                Fragment: React.Fragment,
              })
              .processSync(blok.content).result
          }
        </div>
      )}
      {blok.button.length > 0 && (
        <div className="alert__buttons">
          {blok.button &&
            blok.button.map((content) => (
              <Button
                key={content._uid}
                blok={content}
                className="alert__button"
              />
            ))}
        </div>
      )}
    </div>
  </SbEditable>
)

Alert.propTypes = {
  blok: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
}

export default Alert
